import React from "react";
import "./advantage-enterprises.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../button/button";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
const AdvantageEnterprises = (props: ReferenciaContenido) => {
  const advantageData = props;
  const nombreCategoria = props.nombreCategoria;
  return (
    <div className="a-advantage-container">
      <div className="a-advantage-container__img">
        <img
          src={advantageData.imagenPrincipal?.gatsbyImageData}
          alt={advantageData.imagenPrincipal.title || "imagen empresas"}
        />
      </div>
      <div className="a-advantage-container__content">
        <div className="a-advantage-container__content-title">
          {advantageData.tituloGeneral}
        </div>
        <div className="a-advantage-container__content-desc">
          <p>
            Escríbenos tus comentarios y recibe asesoría para que juntos
            encontremos la solución a lo que estás buscando
          </p>
        </div>
        <div className="a-advantage-container__button">
          <Button
            type="link"
            text={advantageData.tituloBoton}
            classname={`secondary`}
            gtmMark={`gtm${normalizeTwoWords(
              nombreCategoria
            )}${normalizeTwoWords(advantageData.tituloBoton)}`}
            isDisabled={false}
            href={advantageData.redireccionBoton}
          />
        </div>
      </div>
    </div>
  );
};

export default AdvantageEnterprises;
